import i18n from "@sg/i18n";
import { z } from "zod";

const customErrorMap: z.ZodErrorMap = (issue, ctx) => {
  if (issue.code === z.ZodIssueCode.too_small) {
    if (issue.minimum === 1) {
      return { message: i18n.t("required") };
    }
  }
  return { message: ctx.defaultError };
};

export const initializeZod = () => {
  z.setErrorMap(customErrorMap);
};
